import { MARQUEE_ITEMS } from "@/lib/site";

const Row = () => (
  <div className="flex shrink-0 items-center gap-10 pr-10">
    {MARQUEE_ITEMS.map((t, i) => (
      <span key={i} className="flex items-center gap-10">
        <span className="font-display text-2xl md:text-3xl font-medium text-lark-blue/80 whitespace-nowrap">
          {t}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-lark-blue/40" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="marquee" className="bg-lark-light py-7 overflow-hidden">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </section>
);
